import React from 'react';
import CustomLink from 'components/shared/CustomLink';
import { getAssetUrl } from 'lib/config/assetUrls';
import { CustomImage } from '..';
import { PrimaryButton } from '../PrimaryButton';
import { ImageContainer } from './layout';
import styles from './rareInfoModals.module.css';

const cx = (base: string, extra?: string) =>
  extra ? `${base} ${extra}` : base;

interface RareInfoModalDataProps {
  title?: string;
  descriptionTop?: string;
  descriptionBottom?: string;
  btnText?: string;
  img?: string;
  icon?: React.ReactNode;
  listStep?: React.ReactNode;
  listTitle?: React.ReactNode;
  listDescription?: React.ReactNode;
  report?: string;
}

export const RareInfoModal = ({
  className,
  list = false,
  data = [],
  bottomContent,
  title,
  subtitle,
  valuedAt,
  headerImage,
  mainDescription,
}: {
  title?: string;
  subtitle?: string;
  valuedAt?: string;
  className?: string;
  list?: boolean;
  data?: RareInfoModalDataProps[];
  bottomContent?: React.ReactNode;
  headerImage?: string;
  mainDescription?: string;
}) => {
  return (
    <div className={cx(styles.rareInfoModal, className)}>
      <h2>{title}</h2>
      <div
        className="sub-head"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          justifyContent: 'space-between',
        }}
      >
        <p>{subtitle}</p>
        {valuedAt ? (
          <span
            style={{
              color: 'rgba(0, 0, 0, 0.50)',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '120%' /* 14.4px */,
              letterSpacing: '-0.48px',
            }}
          >
            (Valued at {valuedAt})
          </span>
        ) : null}
      </div>
      {headerImage ? (
        <ImageContainer className="rare-info-modal-header-image">
          <CustomImage
            src={headerImage}
            width={1376}
            height={808}
            alt="rare-info-modal-header-image"
            style={{
              margin: '24px 0',
            }}
          />
        </ImageContainer>
      ) : null}
      {mainDescription ? (
        <p className={styles.mainDescription}>{mainDescription}</p>
      ) : null}
      {list ? (
        <>
          {' '}
          <ol>
            {data.map((item, index) => (
              <li key={index}>
                {item.icon}
                <h5>
                  <span>{item.listStep ? item.listStep : null}</span>{' '}
                  {item.listTitle}
                </h5>
                <p>{item.listDescription}</p>
              </li>
            ))}
          </ol>
          {bottomContent ? bottomContent : null}{' '}
        </>
      ) : (
        <div className={styles.powerPlugsInfoDescription}>
          {data.map((benefit, index) => (
            <div key={index} className={styles.benefit}>
              <div>
                <h3>{benefit.title}</h3>
                <p className={styles.description}>{benefit.descriptionTop}</p>
                {benefit.img ? (
                  <ImageContainer>
                    <CustomImage
                      src={benefit.img}
                      width={1376}
                      height={808}
                      alt="rare-info-modal-list-item-image"
                    />
                  </ImageContainer>
                ) : null}
                {benefit.btnText && benefit.report ? (
                  <CustomLink
                    href={getAssetUrl(benefit.report)}
                    download={benefit.report.split('/').pop() || 'report'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      display: 'inline-block',
                    }}
                    // onClick={() => {
                    //   // Analytics tracking for download events
                    //   if (benefit.report) {
                    //     va.track('download-sample-report', {
                    //       report_type: benefit.report.split('/').pop() || 'unknown',
                    //       clicked: true,
                    //     });
                    //   }
                    // }}
                  >
                    <PrimaryButton
                      style={{
                        borderRadius: '24px',
                      }}
                    >
                      {benefit.btnText}
                    </PrimaryButton>
                  </CustomLink>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
